<template>
  <div class="flex items-center justify-center gap-2 mb-8">
    <button
      v-for="(page, index) in pages"
      :key="index"
      @click="changePage(page)"
      :disabled="page === '...'"
      :class="[
        'px-3 py-1 rounded-md',
        { 'bg-gray-700 text-white': page === current },
        { 'text-gray-400 hover:bg-gray-800': page !== current && page !== '...' },
        { 'cursor-default': page === '...' },
      ]"
    >
      {{ page }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  total: number;
  limit: number;
  current: number;
}

const props = defineProps<Props>();
const emit = defineEmits(['change-page']);

const totalPages = computed(() => Math.ceil(props.total / props.limit));

const pages = computed(() => {
  const range = [];
  const total = totalPages.value;
  const current = props.current;

  if (total <= 7) {
    for (let i = 1; i <= total; i++) {
      range.push(i);
    }
  } else {
    range.push(1);
    if (current > 4) {
      range.push('...');
    }

    const start = Math.max(2, current - 1);
    const end = Math.min(total - 1, current + 1);

    for (let i = start; i <= end; i++) {
      range.push(i);
    }

    if (current < total - 3) {
      range.push('...');
    }

    if (total > 1) {
      range.push(total);
    }
  }

  return range;
});

const changePage = (page: number | string) => {
  if (typeof page === 'number') {
    emit('change-page', page);
  }
};
</script>
